<template>
  <div class="restriktionen-legend">
    <div class="restriktionen-legend__items">
      <div v-for="item in legende" :key="item.type" class="restriktionen-legend__row">
        <span
          class="restriktionen-legend__chip"
          :style="{
            backgroundColor: typeConfig(item.type).bgColor,
            color: typeConfig(item.type).textColor,
          }"
        >
          <component :is="typeConfig(item.type).icon" :size="14" />
        </span>
        <span class="restriktionen-legend__label">{{ item.label }}</span>
      </div>
    </div>

    <!-- Trenner und Hinweis erscheinen nur, wenn der Aufrufer einen Hinweistext mitgibt -->
    <template v-if="hinweis">
      <div class="restriktionen-legend__divider"></div>
      <p class="restriktionen-legend__hint">{{ hinweis }}</p>
    </template>
  </div>
</template>

<script>
import restriktionenTypMixin from './restriktionen-typ.mixin.js';
import { RESTRIKTION_TYPE } from './restriktionen.constants.js';

const LEGENDE = [
  { type: RESTRIKTION_TYPE.KEINE_ABREISE, label: 'Wiederkehrende Sperrzeit (keine Abreise)' },
  { type: RESTRIKTION_TYPE.KEINE_ABREISE_HART, label: 'Einmalige Sperrzeit (keine Abreise)' },
  { type: RESTRIKTION_TYPE.KEINE_REISEN, label: 'Gesperrte Saison (keine Reisen)' },
];

export default {
  name: 'RestriktionenLegendeComponent',
  mixins: [restriktionenTypMixin],
  props: {
    hinweis: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      legende: LEGENDE,
    };
  },
};
</script>

<style scoped>
.restriktionen-legend {
  font-family: 'Poppins', Helvetica, 'sans-serif';
}

.restriktionen-legend__items {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.restriktionen-legend__row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.restriktionen-legend__chip {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 26px;
  height: 26px;
  border-radius: var(--radius-sm);
}

.restriktionen-legend__chip :deep(svg) {
  flex-shrink: 0;
  width: 14px;
  height: 14px;
  fill: none;
}

.restriktionen-legend__label {
  font-size: 14px;
  line-height: 16px;
  font-weight: 400;
  color: var(--text-body);
}

.restriktionen-legend__divider {
  margin: 16px 0 8px;
  border-top: 1px solid var(--border);
}

.restriktionen-legend__hint {
  margin: 0;
  font-size: 10px;
  line-height: 16px;
  font-weight: 400;
  color: var(--text-muted);
}
</style>
